import { z } from 'zod/v4'
import * as Statsig from '../statsig'

const triggerSchema = z.enum([
  'card_one_time_payment_success',
  'rewards_statement_credit_success',
  'benefits_enrollment_success',
  'rewards_referral_popup_dismissed',
  'rewards_referral_code_copied',
  'rewards_referral_shared',
  'mortgage_rewards_amount_updated',
  'rewards_points_ledger_viewed',
])

export type Trigger = z.infer<typeof triggerSchema>

export const SurveyConfigurationSchema = z.object({
  validTriggers: z.array(triggerSchema),
  statsigFeatureGate: z.string().optional(),
})

export const surveyIdSchema = z.enum(['2025_JUNE_SURVEY', '2025_JUNE_SURVEY_FOLLOW_UP'])
export type SurveyId = z.infer<typeof surveyIdSchema>

type Configuration = {
  [key in SurveyId]: z.infer<typeof SurveyConfigurationSchema>
}

export const Configuration = {
  '2025_JUNE_SURVEY': {
    validTriggers: [
      'card_one_time_payment_success',
      'rewards_statement_credit_success',
      'benefits_enrollment_success',
      'rewards_referral_popup_dismissed',
      'rewards_referral_code_copied',
      'rewards_referral_shared',
      'mortgage_rewards_amount_updated',
      'rewards_points_ledger_viewed',
    ],
    statsigFeatureGate: Statsig.FeatureGates.Survey2025JuneEnabled,
  },
  '2025_JUNE_SURVEY_FOLLOW_UP': {
    validTriggers: [
      'card_one_time_payment_success',
      'benefits_enrollment_success',
      'mortgage_rewards_amount_updated',
      'rewards_points_ledger_viewed',
    ],
    statsigFeatureGate: Statsig.FeatureGates.Survey2025JuneFollowUpEnabled,
  },
} satisfies Configuration
